import React from "react";
import {
    Column,
    DataGrid,
    Paging,
    Pager,
    HeaderFilter,
    FilterRow,
    FormItem,
} from "devextreme-react/data-grid";
import { Editing } from "devextreme-react/scheduler";
import PaginaToolbar from '../components/PaginaToolbar';
import { criarIndicePrecosDs } from "../DataSources";
import UserInfo from "../UserInfo";
import uiInfo from "../ui-info";

export default class IndicePrecosBox extends React.Component {
    constructor() {
        super();
    }

    render() {
        return (
            <div className={'content-block dx-card responsive-paddings'}>
                <PaginaToolbar titulo="INDICES PREÇOS">
                    <DataGrid
                        dataSource={criarIndicePrecosDs()}
                        showBorders={true}
                        rowAlternationEnabled={true}
                        remoteOperations={true}
                        focusedRowEnabled={true}
                        wordWrapEnabled={true}
                        onInitNewRow={this.initNewRow}>
                        <HeaderFilter visible={true} />
                        <FilterRow visible={true} />
                        <Editing mode={"row"} allowAdding={false} allowUpdating={true} allowDeleting={true} />
                        <Column dataField={'id'} caption={"#"} width={'150'} allowEditing={false} />
                        <Column dataField={'prefeituraId'} caption={"Prefeitura"} visible={false}>
                            <FormItem visible={false}></FormItem>
                        </Column>
                        <Column dataField={'nome'} caption={"Nome"} />
                        <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
                        <Pager
                            showPageSizeSelector={true}
                            allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
                        />
                    </DataGrid>
                </PaginaToolbar>
            </div>
        );
    }
    initNewRow(e) {
        e.data.prefeituraId = UserInfo.getPrefeitura();
    }
}